import { Button } from "@/components/ui/button";
import { TESTIDS } from "@/constants/testIds";
import { Undo2, RotateCcw, Home, Eye } from "lucide-react";

export function ControlBar({ onUndo, onRestart, onHome, onToggleLog, canUndo, disabled }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        data-testid={TESTIDS.undoBtn}
        variant="outline"
        onClick={onUndo}
        disabled={!canUndo || disabled}
        className="rounded-full"
      >
        <Undo2 className="h-4 w-4 mr-2" /> Undo
      </Button>
      <Button
        data-testid={TESTIDS.restartBtn}
        variant="outline"
        onClick={onRestart}
        disabled={disabled}
        className="rounded-full"
      >
        <RotateCcw className="h-4 w-4 mr-2" /> Restart
      </Button>
      <Button
        data-testid={TESTIDS.reviewBtn}
        variant="ghost"
        onClick={onToggleLog}
        className="rounded-full"
      >
        <Eye className="h-4 w-4 mr-2" /> Event log
      </Button>
      <Button
        data-testid={TESTIDS.homeBtn}
        variant="ghost"
        onClick={onHome}
        className="rounded-full ml-auto"
      >
        <Home className="h-4 w-4 mr-2" /> Home
      </Button>
    </div>
  );
}
